import type { QueryClient } from '@tanstack/react-query'

import { queryGroupGet } from '@api/group/group.queries'

export const groupSheetPreload = async (
  groupUuid: string,
  queryClient: QueryClient,
) => queryClient.ensureQueryData(queryGroupGet(groupUuid))
